// removed by extract-text-webpack-plugin
module.exports = {"layout":"index_layout_3VTha","leftMenu":"index_leftMenu_3gHuo","menuActive":"index_menuActive_3Kdfo","content":"index_content_2Z7R5"};


//////////////////
// WEBPACK FOOTER
// ./src/components/personal/index.scss
// module id = 1553
// module chunks = 0